export default "__VITE_ASSET__ixN_ocyy__"